import { createRootRoute, Outlet } from '@tanstack/react-router';
import '../index.css'; // Import global styles

export const Route = createRootRoute({
  component: () => (
    <>
      {/* Add common layout elements here if needed, e.g., Navbar, Footer */}
      <div>
        {/* Example: Add padding around outlet */}
        <Outlet />
      </div>
    </>
  ),
});
